<template>
    <div class="d-flex flex-column align-items-center justify-content-center h-100 py-5 carousel-container">
        <div class="d-flex align-items-center align-self-start">
            <b-img style="max-width: 55px" class="mr-2 my-0" src="../../static/faradai_logo_icon_white.png"></b-img>
            <h3 class="text-white mb-0 font-weight-bold">{{ $t('Carbon Intelligence') }}</h3>
        </div>
        <b-carousel
            v-model="slide"
            class="d-flex h-100"
            indicators
            :interval="4000"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
        >
            <!-- no-animation -->
            <!-- img-width="600" -->
            <b-carousel-slide
                v-for="item in carouselItems"
                :key="item.id"
                class="custom-carousel-item"
            >
                <template #img>
                    <img
                        class="custom-carousel-img"
                        :src="item.image"
                    >
                </template>
                    <h2 class="my-4 font-weight-bold">{{$t(item.title)}}</h2>
                    <p>{{$t(item.text)}}</p>
            </b-carousel-slide>
        </b-carousel>
    </div>
</template>

<script>
export default {
    name: 'Carousel',
    data() {
        return {
            carouselItems: [
                {
                    id: 1,
                    image: '../../static/carousel_images/ConsolidateSustainabilityData_illustration.svg',
                    title: 'ConsolidateSustainabilityDataTitle',
                    text: 'ConsolidateSustainabilityDataText'
                },
                {
                    id: 2,
                    image: '../../static/carousel_images/StreamlineGHGEmissionsReporting_illustration.svg',
                    title: 'StreamlineGHGEmissionsReportingTitle',
                    text: 'StreamlineGHGEmissionsReportingText'
                },
                {
                    id: 3,
                    image: '../../static/carousel_images/TrackNetZeroGoals_illustration.svg',
                    title: 'TrackNetZeroGoalsTitle',
                    text: 'TrackNetZeroGoalsText'
                },
                {
                    id: 4,
                    image: '../../static/carousel_images/manageAudits_illustration.svg',
                    title: 'ManageAuditsTitle',
                    text: 'ManageAuditsText'
                },
                {
                    id: 5,
                    image: '../../static/carousel_images/CreateSustainabilityRepository_illustration.svg',
                    title: 'CreateSustainabilityRepositoryTitle',
                    text: 'CreateSustainabilityRepositoryText'
                }
            ],
            slide: 0,
            sliding: null
        };
    },
    methods: {
      onSlideStart() {
        this.sliding = true
      },
      onSlideEnd() {
        this.sliding = false
      }
    }
};
</script>

<style lang="scss">
.carousel-container {
    margin: 0 11%
}

.carousel-inner,
.custom-carousel-item {
    height: 100%;
}

.custom-carousel-item.active,
.custom-carousel-item.carousel-item-left, 
.custom-carousel-item.carousel-item-right,
.custom-carousel-item.carousel-item-next, 
.custom-carousel-item.carousel-item-prev {
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
}
.custom-carousel-img {
    max-height: 300px;
}
.custom-carousel-item .carousel-caption {
    position: relative;
    right: auto;
    left: auto;
}
.carousel-indicators li {
    border-radius: 50% !important;
    height: .5em !important;
    width: .5em !important;
}
// .card-img-left{
//     align-self: center;
//     justify-content: center;
//     margin: auto;
// }
// .carousel-indicators {
//     bottom: -10px;
// }
// .carousel.item .img-fluid{
//     height: 50 !important;
//     width: 50 !important;
//     align-self: center;
//     top: 0;
//     position: relative;
// }

// .carousel-item .card .card-img-top{
//     max-height: 250px;
//     min-height: 50px;
//     max-width: 300px;
//     min-width: 50px;
//     height: 100% !important;
//     width: 100% !important;
//     align-self: center;
//     top: 0;
//     position: relative;
// }
    
</style>

<i18n src="../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "ConsolidateSustainabilityDataTitle": "Sürdürülebilirlik Verilerini Tek Platformda Birleştirin",
            "ConsolidateSustainabilityDataText": "İyi tasarlanmış veri giriş alanlarıyla karbon verisi toplamayı basitleştirin ve sürdürülebilirlik verilerini tek bir merkezde birleştirin.",
            "StreamlineGHGEmissionsReportingTitle": "Sera Gazı Emisyon Raporlarını Kolaylaştırın",
            "StreamlineGHGEmissionsReportingText": "Zorunlu ve gönüllü raporlama gereksinimlerini basit ve kolay bir şekilde sunmak için Enerji, Atık ve Taşıma verilerini derleyin. IPCC, DEFRA, EPA gibi genişleyen küresel emisyon faktörleri veritabanlarıyla Kapsam 1, 2 ve 3 GHG emisyonlarını hesaplayın ve ISO 140001, ISO 14064 ve GHG Protokol çerçevelerine uyun.",
            "TrackNetZeroGoalsTitle": "Net Sıfır Hedefleri Takip Edin",
            "TrackNetZeroGoalsText": "Kurumsal veya faaliyet düzeyinde hedefler belirleyin ve sürdürülebilirlik hedeflerine yönelik ilerlemeyi izleyin. Lokasyonların normalize edilmiş emisyon verilerini birbirine göre kıyaslayın ve yıldan yıla değişiklikleri takip edin.",
            "ManageAuditsTitle": "Denetimleri Yönetin",
            "ManageAuditsText": "Kurumunuzun çevre performansını iç ve dış denetimlerle değerlendirin, uygunsuzlukları belirleyin ve aksiyon planlarını takip edin.",
            "CreateSustainabilityRepositoryTitle": "Kurumsal Sürdürülebilirlik Hafızası Oluşturun",
            "CreateSustainabilityRepositoryText": "Belgeleri, faturaları ve denetim kanıtı dosyalarını tek bir yerde saklayın ve belgeleri ihtiyaç duyduğunuz her yerde ve zamanda dağıtım, erişim ve kullanım için hazır hale getirin."
        },
        "en": {
            "ConsolidateSustainabilityDataTitle": "Consolidate Sustainability Data",
            "ConsolidateSustainabilityDataText": "Simplify carbon data collection with well-designed data entry fields and consolidate sustainability data on a single global hub.",
            "StreamlineGHGEmissionsReportingTitle": "Streamline GHG Emissions Reporting",
            "StreamlineGHGEmissionsReportingText": "Compile Energy, Waste and Transport data to submit mandatory and voluntary reporting requirements with simplicity and ease. Calculate Scope 1, 2 and 3 GHG emissions with expanding global emission factors databases like IPCC, DEFRA, EPA and comply with ISO 140001, ISO 14064 and GHG Protocol frameworks.",
            "TrackNetZeroGoalsTitle": "Track Net Zero Goals",
            "TrackNetZeroGoalsText": "Set organizational or activity level targets and track progress towards sustainability goals. Benchmark normalized emission data of locations against each other and track year over year changes.",
            "ManageAuditsTitle": "Manage Audits",
            "ManageAuditsText": "Evaluate the environmental performance of your organization with internal and external audits, determine nonconformities and track action plans.",
            "CreateSustainabilityRepositoryTitle": "Create a Sustainability Repository",
            "CreateSustainabilityRepositoryText": "Keep documented information, invoices and audit evidence files in one place and make documents available for distribution, access and use whenever and wherever you need."
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/components/Carousel.vue